/**
 * Composable shipping-rates (cost/tarif).
 *
 * staleTime: 1 jam — tarif jarang berubah.
 * cacheTime default (2 jam).
 *
 * Pemakaian list:
 *   const params = reactive({ page: 1, limit: 10, search: "" });
 *   const { data, isLoading, refetch } = useShippingCosts(computed(() => params));
 *
 * Detail (lookup by id, lazy via qc.fetchQuery):
 *   const qc = useQueryClient();
 *   const data = await qc.fetchQuery({
 *     queryKey: keys.shipping.costDetail(id),
 *     queryFn: () => fetchShippingCostById(id),
 *     staleTime: 5 * 60 * 1000,
 *   });
 */
import { computed, unref } from "@vue/composition-api";
import { useQuery } from "@tanstack/vue-query";
import { keys } from "@/queries/keys";
import {
  fetchShippingCosts,
  fetchShippingCostById,
} from "@/queries/api/shipping";

const LIST_STALE = 60 * 60 * 1000; // 1 jam
const DETAIL_STALE = 5 * 60 * 1000; // 5 menit

function p(input) {
  return unref(input);
}

export function useShippingCosts(params = {}, options = {}) {
  return useQuery({
    queryKey: computed(() => keys.shipping.costs(p(params))),
    queryFn: () => fetchShippingCosts(p(params)),
    staleTime: LIST_STALE,
    ...options,
  });
}

export function useShippingCost(id, options = {}) {
  return useQuery({
    queryKey: computed(() => keys.shipping.costDetail(p(id))),
    queryFn: () => fetchShippingCostById(p(id)),
    staleTime: DETAIL_STALE,
    enabled: computed(() => !!p(id)),
    ...options,
  });
}

/* Re-export fetcher untuk qc.fetchQuery one-shot. */
export { fetchShippingCostById, fetchShippingCosts };
